import withNavigate from "../../../routes/withNavigate";
import ProfileContainer from "./ProfileContainer.jsx";
import ProfileStore from "./ProfileStore";

export default ProfileStore(withNavigate(ProfileContainer));